import React from "react";
import "./index.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>© {new Date().getFullYear()} Wensystem. Todos os direitos reservados. (v.05-12-2025)
          <img className="footer-logo"
            src="https://wensystem.com.br/wp-content/uploads/elementor/thumbs/wen-p623lz4kkweo04kemh8w9xxnnnil4y52p7qm1kzev8-q2udnzzadgwf28zy01to57p9qt3p3g9kjh2rvsjzzc.png" 
            alt="Logo Wensystem" />
        </p>
      </div>
    </footer>
  );
};

export default Footer;